// import Logger from 'Logger'
import { popShow } from '../../manager/mall.event'
import { API_PATH } from '../../config'
import { $ajax } from '../../utils'

function firendErrorPop(payModel) {
  popShow({
    title: '선물불가',
    message: '친구에게 선물을 보낼 수 없습니다.',
  })
  payModel.resetFriend()
}
/**
 * 결과 값음 모델에 데이터 넣은 후 validate: true 옵션으로 검증
 * pay.validate validateGift()
 */
export function requestFriendGsnInfo(gsn, nickname) {
  var payModel = this

  return $ajax(API_PATH.VALITDATE_FRIEND_GSN, {
    target_gsn: gsn,
    goods_id_list: this.get('goodsIdList').join('_'),
  })
    .done(function (res) {
      var result = res.result
      var myInfo = result.sender_pplus_member_info

      if (result.resultCode) {
        payModel.setFriendData({
          friendResultCode: result.resultCode,
          friendId: nickname,
          friendGSN: gsn,
          friendNickname: nickname,
          myNickname: myInfo && myInfo.nickname,
          billingUrl: result.pmang_cash_url_info || null,
          isFriendSearched: true,
        })
      }
    })
    .fail(function () {
      firendErrorPop(payModel)
    })
}
/**
 * 결과 값음 모델에 데이터 넣은 후 validate: true 옵션으로 검증
 * pay.validate validateGift()
 */
export function requestFriendIdInfo(id) {
  var payModel = this

  return $ajax(API_PATH.VALITDATE_FRIEND_ID, {
    target_id: id,
    goods_id_list: this.get('goodsIdList').join('_'),
  })
    .done(function (res) {
      var result = res.result
      var friendInfo = result.target_pplus_friend_info
      var myInfo = result.sender_pplus_member_info

      if (result.resultCode) {
        payModel.setFriendData({
          friendResultCode: result.resultCode,
          friendId: id,
          friendGSN: friendInfo && friendInfo.member_id,
          friendNickname: friendInfo && friendInfo.nickname,
          myNickname: myInfo && myInfo.nickname,
          billingUrl: result.pmang_cash_url_info || null,
          isFriendSearched: true,
        })
      } else {
        popShow({
          message:
            '선물하는 회원을 찾을 수 없습니다 <br />다시 확인 후 입력하세요.',
        })
        payModel.resetFriend()
      }
    })
    .fail(function () {
      firendErrorPop(payModel)
    })
}
